import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { doc, getDoc, setDoc } from 'firebase/firestore';

export default function Settings() {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [bannersMr, setBannersMr] = useState('');
  const [bannersEn, setBannersEn] = useState('');
  const [settings, setSettings] = useState({
    baseCharge: 20,
    perKmCharge: 20,
    freeThreshold: 0.5,
    freeOrdersCount: 2,
    minOrderValue: 100,
    upiId: '9763406376@upi',
    businessName: 'Smart Sangola',
    backendApiUrl: '',
    razorpayKey: '',
    geminiApiKey: '',
    supportPhone: '+919763406376',
    deliveryBoyNoticeMr: '',
    deliveryBoyNoticeEn: '',
    transporterNoticeMr: '',
    transporterNoticeEn: '',
    shopkeeperNoticeMr: '',
    shopkeeperNoticeEn: '',
    isAppActive: true
  });

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const docRef = doc(db, 'settings', 'delivery');
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        setSettings(docSnap.data());
      }
      
      const bannersRef = doc(db, 'settings', 'banners');
      const bannersSnap = await getDoc(bannersRef);
      if (bannersSnap.exists()) {
        const data = bannersSnap.data();
        setBannersMr((data.bannersMr || []).join('\n'));
        setBannersEn((data.bannersEn || []).join('\n'));
      }
    } catch (error) {
      console.error("Error fetching settings:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      await setDoc(doc(db, 'settings', 'delivery'), settings);
      
      const arrMr = bannersMr.split('\n').map(s => s.trim()).filter(Boolean);
      const arrEn = bannersEn.split('\n').map(s => s.trim()).filter(Boolean);
      await setDoc(doc(db, 'settings', 'banners'), {
        bannersMr: arrMr,
        bannersEn: arrEn
      });
      
      alert('Settings and Banners saved successfully!');
    } catch (error) {
      console.error("Error saving settings:", error);
      alert('Failed to save settings.');
    } finally {
      setSaving(false);
    }
  };

  const handleToggleAppStatus = async () => {
    const newStatus = settings.isAppActive === false ? true : false;
    setSaving(true);
    try {
      setSettings(prev => ({ ...prev, isAppActive: newStatus }));
      await setDoc(doc(db, 'settings', 'delivery'), { ...settings, isAppActive: newStatus });
      alert(newStatus ? '🟢 App is now LIVE!' : '🔴 App is now in MAINTENANCE MODE!');
    } catch (error) {
      console.error("Error toggling app status:", error);
      alert('Failed to update app status.');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <div className="loading-container">Loading Settings...</div>;
  }

  return (
    <div className="page-container">
      <div className="card">
        <div className="card-header">
          <div className="card-title">डिलिव्हरी चार्जेस सेटिंग्ज | Delivery Settings</div>
          <div className="card-subtitle">Manage delivery fees and order constraints</div>
        </div>

        <div className="settings-form" style={{ padding: '20px', display: 'flex', flexDirection: 'column', gap: '20px' }}>
          
          {/* Global App Status Toggle */}
          <div className="card-header" style={{ padding: '0 0 10px 0', borderBottom: '1px solid var(--border)', marginBottom: '5px' }}>
            <div className="card-title" style={{ fontSize: '17px', color: 'var(--danger)' }}>🚨 मुख्य ॲप नियंत्रण | Global App Status</div>
            <div className="card-subtitle">Turn off the entire customer app for maintenance</div>
          </div>

          <div className="input-group" style={{ 
            background: settings.isAppActive !== false ? 'rgba(16, 185, 129, 0.1)' : 'rgba(239, 68, 68, 0.1)', 
            padding: '16px', 
            borderRadius: '12px', 
            border: '1px solid ' + (settings.isAppActive !== false ? 'var(--success)' : 'var(--danger)'), 
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: 'center',
            marginBottom: '15px'
          }}>
            <div>
              <div style={{ fontWeight: '800', fontSize: '15px', color: settings.isAppActive !== false ? 'var(--success)' : 'var(--danger)' }}>
                {settings.isAppActive !== false ? '🟢 APP IS LIVE (ॲप चालू आहे)' : '🔴 MAINTENANCE MODE (ॲप बंद आहे)'}
              </div>
              <small style={{ color: 'var(--text-muted)', display: 'block', marginTop: '4px' }}>
                {settings.isAppActive !== false 
                  ? 'Customers can browse shops, book rides/parcels normally.' 
                  : 'All customers will see a full-screen maintenance notice and cannot use any features.'}
              </small>
            </div>
            <button
              onClick={handleToggleAppStatus}
              className={`btn ${settings.isAppActive !== false ? 'btn-danger' : 'btn-success'}`}
              style={{ padding: '10px 18px', fontWeight: 'bold', border: 'none', cursor: 'pointer' }}
              type="button"
              disabled={saving}
            >
              {settings.isAppActive !== false ? '🛑 Put Offline (ॲप बंद करा)' : '✅ Go Live (ॲप चालू करा)'}
            </button>
          </div>

          <hr style={{ border: '0', borderTop: '1px solid var(--border)', margin: '5px 0 15px 0' }} />

          <div className="input-group">
            <label className="input-label">
              Base Charge (₹) - फिक्स चार्ज
            </label>
            <input 
              type="number" 
              value={settings.baseCharge} 
              onChange={(e) => setSettings({...settings, baseCharge: Number(e.target.value)})}
              className="input"
            />
            <small style={{ color: 'var(--text-muted)' }}>Location न मिळाल्यास लावला जाणारा चार्ज</small>
          </div>

          <div className="input-group">
            <label className="input-label">
              Per KM Charge (₹) - प्रति किलोमीटर चार्ज
            </label>
            <input 
              type="number" 
              value={settings.perKmCharge} 
              onChange={(e) => setSettings({...settings, perKmCharge: Number(e.target.value)})}
              className="input"
            />
          </div>

          <div className="input-group">
            <label className="input-label">
              Free Delivery Threshold (KM) - किती किमी पर्यंत फ्री?
            </label>
            <input 
              type="number" 
              step="0.1"
              value={settings.freeThreshold} 
              onChange={(e) => setSettings({...settings, freeThreshold: Number(e.target.value)})}
              className="input"
            />
          </div>

          <div className="input-group">
            <label className="input-label">
              Free Orders Count - पहिल्या किती ऑर्डर्स फ्री?
            </label>
            <input 
              type="number" 
              value={settings.freeOrdersCount} 
              onChange={(e) => setSettings({...settings, freeOrdersCount: Number(e.target.value)})}
              className="input"
            />
          </div>

          <div className="input-group">
            <label className="input-label">
              Minimum Order Value (₹) - कमीत कमी ऑर्डर रक्कम
            </label>
            <input 
              type="number" 
              value={settings.minOrderValue} 
              onChange={(e) => setSettings({...settings, minOrderValue: Number(e.target.value)})}
              className="input"
            />
          </div>

          <div className="input-group">
            <label className="input-label">
              Shopkeeper Deduction (%) - दुकानदार कमिशन (%)
            </label>
            <input 
              type="number" 
              value={settings.shopkeeperDeductionPercent} 
              onChange={(e) => setSettings({...settings, shopkeeperDeductionPercent: Number(e.target.value)})}
              className="input"
            />
            <small style={{ color: 'var(--text-muted)' }}>दुकानदाराच्या ओरिजिनल रेट मधून एवढे % कट होतील</small>
          </div>

          <div className="input-group">
            <label className="input-label">
              Delivery Boy Pay (₹/Order) - प्रति ऑर्डर डिलिव्हरी बॉयची कमाई
            </label>
            <input 
              type="number" 
              value={settings.deliveryBoyPayPerOrder} 
              onChange={(e) => setSettings({...settings, deliveryBoyPayPerOrder: Number(e.target.value)})}
              className="input"
            />
            <small style={{ color: 'var(--text-muted)' }}>एका डिलिव्हरी मागे डिलिव्हरी बॉयला मिळणारे पैसे</small>
          </div>

          <div className="input-group">
            <label className="input-label">
              UPI ID (for Direct Payment)
            </label>
            <input 
              type="text" 
              value={settings.upiId} 
              onChange={(e) => setSettings({...settings, upiId: e.target.value})}
              className="input"
            />
          </div>

          <div className="input-group">
            <label className="input-label">
              Business Name (for UPI)
            </label>
            <input 
              type="text" 
              value={settings.businessName} 
              onChange={(e) => setSettings({...settings, businessName: e.target.value})}
              className="input"
            />
          </div>

          <div className="input-group">
            <label className="input-label">
              Support Phone Number (मदत / हेल्पलाईन नंबर)
            </label>
            <input 
              type="text" 
              value={settings.supportPhone || ''} 
              onChange={(e) => setSettings({...settings, supportPhone: e.target.value})}
              className="input"
              placeholder="+919763406376"
            />
            <small style={{ color: 'var(--text-muted)' }}>ग्राहकांना मदत हवी असल्यास या नंबरवर कॉल लागेल (उदा. +919763406376)</small>
          </div>

          <div className="input-group">
            <label className="input-label">
              Payment Backend API URL (लाइव्ह पेमेंट सर्वर API URL)
            </label>
            <input 
              type="text" 
              value={settings.backendApiUrl || ''} 
              onChange={(e) => setSettings({...settings, backendApiUrl: e.target.value})}
              className="input"
              placeholder="https://us-central1-smart-sangola.cloudfunctions.net/payment"
            />
            <small style={{ color: 'var(--text-muted)' }}>उदा. https://us-central1-smart-sangola.cloudfunctions.net/payment</small>
          </div>

          <div className="input-group">
            <label className="input-label">
              Active Payment Gateway (सक्रिय पेमेंट गेटवे)
            </label>
            <select
              value={settings.paymentGateway || 'cashfree'}
              onChange={(e) => setSettings({...settings, paymentGateway: e.target.value})}
              className="input"
            >
              <option value="cashfree">Cashfree Payments (सक्रिय)</option>
              <option value="razorpay">Razorpay</option>
              <option value="phonepe">PhonePe PG</option>
            </select>
            <small style={{ color: 'var(--text-muted)' }}>ॲपमध्ये ग्राहकांसाठी वापरला जाणारा पेमेंट गेटवे निवडा</small>
          </div>

          <div className="input-group">
            <label className="input-label">
              Gemini AI API Key (for Chatbot)
            </label>
            <input 
              type="text" 
              value={settings.geminiApiKey || ''} 
              onChange={(e) => setSettings({...settings, geminiApiKey: e.target.value})}
              className="input"
              placeholder="AIzaSyD..."
            />
            <small style={{ color: 'var(--text-muted)' }}>Enter your free Google Gemini API Key from Google AI Studio to enable the smart AI chatbot</small>
          </div>

          <hr style={{ border: '0', borderTop: '1px solid var(--border)', margin: '10px 0' }} />
          
          <div className="card-header" style={{ padding: '0 0 10px 0' }}>
            <div className="card-title" style={{ fontSize: '18px' }}>बाईक टॅक्सी दर | Bike Taxi Fares</div>
            <div className="card-subtitle">Set taxi fares for Bike, Auto, and Cab rides</div>
          </div>

          <div style={{ display: 'flex', gap: 12 }}>
            <div className="input-group" style={{ flex: 1 }}>
              <label className="input-label">Bike Taxi Base Fare (₹)</label>
              <input 
                type="number" 
                value={settings.bikeTaxiBaseFare || 20} 
                onChange={(e) => setSettings({...settings, bikeTaxiBaseFare: Number(e.target.value)})}
                className="input"
              />
            </div>
            <div className="input-group" style={{ flex: 1 }}>
              <label className="input-label">Bike Taxi Per KM (₹)</label>
              <input 
                type="number" 
                value={settings.bikeTaxiPerKm || 5} 
                onChange={(e) => setSettings({...settings, bikeTaxiPerKm: Number(e.target.value)})}
                className="input"
              />
            </div>
          </div>

          <div style={{ display: 'flex', gap: 12 }}>
            <div className="input-group" style={{ flex: 1 }}>
              <label className="input-label">Auto Ride Base Fare (₹)</label>
              <input 
                type="number" 
                value={settings.autoBaseFare || 40} 
                onChange={(e) => setSettings({...settings, autoBaseFare: Number(e.target.value)})}
                className="input"
              />
            </div>
            <div className="input-group" style={{ flex: 1 }}>
              <label className="input-label">Auto Ride Per KM (₹)</label>
              <input 
                type="number" 
                value={settings.autoPerKm || 10} 
                onChange={(e) => setSettings({...settings, autoPerKm: Number(e.target.value)})}
                className="input"
              />
            </div>
          </div>

          <div style={{ display: 'flex', gap: 12 }}>
            <div className="input-group" style={{ flex: 1 }}>
              <label className="input-label">Cab Ride Base Fare (₹)</label>
              <input 
                type="number" 
                value={settings.cabBaseFare || 80} 
                onChange={(e) => setSettings({...settings, cabBaseFare: Number(e.target.value)})}
                className="input"
              />
            </div>
            <div className="input-group" style={{ flex: 1 }}>
              <label className="input-label">Cab Ride Per KM (₹)</label>
              <input 
                type="number" 
                value={settings.cabPerKm || 15} 
                onChange={(e) => setSettings({...settings, cabPerKm: Number(e.target.value)})}
                className="input"
              />
            </div>
          </div>

          <hr style={{ border: '0', borderTop: '1px solid var(--border)', margin: '10px 0' }} />
          
          <div className="card-header" style={{ padding: '0 0 10px 0' }}>
            <div className="card-title" style={{ fontSize: '18px' }}>पार्सल डिलिव्हरी दर | Parcel Delivery Fares</div>
            <div className="card-subtitle">Set shipping rates for logistics delivery</div>
          </div>

          <div style={{ display: 'flex', gap: 12 }}>
            <div className="input-group" style={{ flex: 1 }}>
              <label className="input-label">Parcel Bike Base (₹)</label>
              <input 
                type="number" 
                value={settings.parcelBikeBase || 30} 
                onChange={(e) => setSettings({...settings, parcelBikeBase: Number(e.target.value)})}
                className="input"
              />
            </div>
            <div className="input-group" style={{ flex: 1 }}>
              <label className="input-label">Parcel Bike Per KM (₹)</label>
              <input 
                type="number" 
                value={settings.parcelBikePerKm || 7} 
                onChange={(e) => setSettings({...settings, parcelBikePerKm: Number(e.target.value)})}
                className="input"
              />
            </div>
          </div>

          <div style={{ display: 'flex', gap: 12 }}>
            <div className="input-group" style={{ flex: 1 }}>
              <label className="input-label">Parcel Auto Base (₹)</label>
              <input 
                type="number" 
                value={settings.parcelAutoBase || 60} 
                onChange={(e) => setSettings({...settings, parcelAutoBase: Number(e.target.value)})}
                className="input"
              />
            </div>
            <div className="input-group" style={{ flex: 1 }}>
              <label className="input-label">Parcel Auto Per KM (₹)</label>
              <input 
                type="number" 
                value={settings.parcelAutoPerKm || 12} 
                onChange={(e) => setSettings({...settings, parcelAutoPerKm: Number(e.target.value)})}
                className="input"
              />
            </div>
          </div>

          <div style={{ display: 'flex', gap: 12 }}>
            <div className="input-group" style={{ flex: 1 }}>
              <label className="input-label">Parcel Tempo Base (₹)</label>
              <input 
                type="number" 
                value={settings.parcelTempoBase || 150} 
                onChange={(e) => setSettings({...settings, parcelTempoBase: Number(e.target.value)})}
                className="input"
              />
            </div>
            <div className="input-group" style={{ flex: 1 }}>
              <label className="input-label">Parcel Tempo Per KM (₹)</label>
              <input 
                type="number" 
                value={settings.parcelTempoPerKm || 20} 
                onChange={(e) => setSettings({...settings, parcelTempoPerKm: Number(e.target.value)})}
                className="input"
              />
            </div>
          </div>

          <hr style={{ border: '0', borderTop: '1px solid var(--border)', margin: '10px 0' }} />
          
          <div className="card-header" style={{ padding: '0 0 10px 0' }}>
            <div className="card-title" style={{ fontSize: '18px' }}>डॅशबोर्ड घोषणा | Dashboard Announcements</div>
            <div className="card-subtitle">Delivery Partner, Transporter/Rider आणि Shopkeeper डॅशबोर्डवर दिसणारी घोषणा सेट करा</div>
          </div>

          <div style={{ display: 'flex', gap: 12 }}>
            <div className="input-group" style={{ flex: 1 }}>
              <label className="input-label">डिलिव्हरी बॉय घोषणा (मराठी) | Delivery Boy Notice (Marathi)</label>
              <input 
                type="text" 
                value={settings.deliveryBoyNoticeMr || ''} 
                onChange={(e) => setSettings({...settings, deliveryBoyNoticeMr: e.target.value})}
                className="input"
                placeholder="मदुद भागातील ऑर्डर्स आता जास्त आहेत. तिथे लक्ष द्या!"
              />
            </div>
            <div className="input-group" style={{ flex: 1 }}>
              <label className="input-label">डिलिव्हरी बॉय घोषणा (English) | Delivery Boy Notice (English)</label>
              <input 
                type="text" 
                value={settings.deliveryBoyNoticeEn || ''} 
                onChange={(e) => setSettings({...settings, deliveryBoyNoticeEn: e.target.value})}
                className="input"
                placeholder="Orders in Madud area are high right now. Focus there!"
              />
            </div>
          </div>

          <div style={{ display: 'flex', gap: 12 }}>
            <div className="input-group" style={{ flex: 1 }}>
              <label className="input-label">प्रवास व पार्सल घोषणा (मराठी) | Transporter Notice (Marathi)</label>
              <input 
                type="text" 
                value={settings.transporterNoticeMr || ''} 
                onChange={(e) => setSettings({...settings, transporterNoticeMr: e.target.value})}
                className="input"
                placeholder="सांगोला तालुक्यात नवीन बुकिंग सुरू झाली आहे!"
              />
            </div>
            <div className="input-group" style={{ flex: 1 }}>
              <label className="input-label">प्रवास व पार्सल घोषणा (English) | Transporter Notice (English)</label>
              <input 
                type="text" 
                value={settings.transporterNoticeEn || ''} 
                onChange={(e) => setSettings({...settings, transporterNoticeEn: e.target.value})}
                className="input"
                placeholder="New booking requests have started in Sangola Taluka!"
              />
            </div>
          </div>

          <div style={{ display: 'flex', gap: 12 }}>
            <div className="input-group" style={{ flex: 1 }}>
              <label className="input-label">दुकानदार घोषणा (मराठी) | Shopkeeper Notice (Marathi)</label>
              <input 
                type="text" 
                value={settings.shopkeeperNoticeMr || ''} 
                onChange={(e) => setSettings({...settings, shopkeeperNoticeMr: e.target.value})}
                className="input"
                placeholder="ऑर्डर मिळाल्यावर ती लवकरात लवकर तयार (Ready) करा."
              />
            </div>
            <div className="input-group" style={{ flex: 1 }}>
              <label className="input-label">दुकानदार घोषणा (English) | Shopkeeper Notice (English)</label>
              <input 
                type="text" 
                value={settings.shopkeeperNoticeEn || ''} 
                onChange={(e) => setSettings({...settings, shopkeeperNoticeEn: e.target.value})}
                className="input"
                placeholder="Prepare the order as soon as you receive it."
              />
            </div>
          </div>

          <hr style={{ border: '0', borderTop: '1px solid var(--border)', margin: '10px 0' }} />
          
          <div className="card-header" style={{ padding: '0 0 10px 0' }}>
            <div className="card-title" style={{ fontSize: '18px' }}>बॅनर सेटिंग्ज | Home Screen Banners</div>
            <div className="card-subtitle">प्रत्येक ओळीवर १ बॅनर टाका (One banner text per line)</div>
          </div>

          <div className="input-group">
            <label className="input-label">
              Marathi Banners (मराठी)
            </label>
            <textarea 
              rows="4"
              value={bannersMr} 
              onChange={(e) => setBannersMr(e.target.value)}
              className="input"
              style={{ fontFamily: 'inherit', padding: '10px', resize: 'vertical' }}
              placeholder="🎉 पहिली २ डिलिव्हरी मोफत!&#10;⚡ सांगोल्यातील सर्व दुकाने आता एकाच ॲपवर!"
            />
          </div>

          <div className="input-group">
            <label className="input-label">
              English Banners
            </label>
            <textarea 
              rows="4"
              value={bannersEn} 
              onChange={(e) => setBannersEn(e.target.value)}
              className="input"
              style={{ fontFamily: 'inherit', padding: '10px', resize: 'vertical' }}
              placeholder="🎉 First 2 Deliveries FREE!&#10;⚡ All shops in Sangola now in one app!"
            />
          </div>

          <button 
            onClick={handleSave} 
            disabled={saving}
            className="btn btn-primary"
            style={{ padding: '12px', justifyContent: 'center' }}
          >
            {saving ? 'Saving...' : 'Save Settings'}
          </button>
        </div>
      </div>
    </div>
  );
}
